// DonationFailure.js
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Heading, Text, VStack,Link, Button} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import banner from "../../assets/images/donation_banner.jpg";


const DonationFailure = () => (
  <Box
    h="100vh"
    w="100vw"
    bgImage={`url(${banner})`}
    bgSize="cover"
    bgPosition="center"
    display="flex"
    alignItems="center"
    justifyContent="center"
    p={6}
    color="white"
  >
    <Link as={RouterLink} to="/home" position="absolute" top={4} left={4}>
      <Button
        colorScheme="green"
        variant="outline"
        leftIcon={<ArrowBackIcon />}
      >
        Home
      </Button>
    </Link>
    <Box
      bg="rgba(0, 0, 0, 0.7)"
      borderRadius="lg"
      p={10}
      maxW="500px"
      textAlign="center"
    >
      <VStack spacing={4}>
        <Heading size="xl" mb={4}>
          Donation Failed
        </Heading>
        <Text fontSize="lg">
          We couldn’t process your donation. Please try again, or contact support if you continue to have issues.
        </Text>
      </VStack>
    </Box>
  </Box>
);

export default DonationFailure;
